import React, {useContext} from 'react';
import {WMSContext} from "../../context/WMSContext";
import WmsDesktopLayout from "../../wmsDesktopLayout";
import WmsMobileLayout from "../../wmsMobileLayout";
import {Grid} from "@mui/material";
import OrderTracker from "./components/OrderTracker";
import PageTitle from "../../../../components/WMS/Mobile/PageTitle";
import {FormattedMessage} from "react-intl";
import HiveList from "./components/HiveList";

function WMSSummary() {
    const {isMobile} = useContext(WMSContext)

    if (isMobile) {
        return (
            <WmsMobileLayout>
                <WmsMobileLayout.LeftHeader></WmsMobileLayout.LeftHeader>
                <WmsMobileLayout.RightHeader></WmsMobileLayout.RightHeader>
                <WmsMobileLayout.Content>
                    <Grid container direction={"column"}>
                        <PageTitle
                            title={<FormattedMessage id={"wms.admin_wms_summary.title"}/> }
                            subtitle={<FormattedMessage id={"wms.admin_wms_summary.subtitle"}/> }
                        />

                        <OrderTracker />

                        <HiveList />
                    </Grid>
                </WmsMobileLayout.Content>
            </WmsMobileLayout>
        )
    }

    return (
        <WmsDesktopLayout customStyle={{minWidth: 0}} >
            <WmsDesktopLayout.Content customStyle={{minWidth: 0, overflow: 'auto'}}>
                <Grid container direction={"column"} gap={"16px"}>
                    <PageTitle
                        title={<FormattedMessage id={"wms.admin_wms_summary.title"}/> }
                        subtitle={<FormattedMessage id={"wms.admin_wms_summary.subtitle"}/> }
                        isDesktop={true}
                    />

                    <OrderTracker />

                    <HiveList />
                </Grid>
            </WmsDesktopLayout.Content>
        </WmsDesktopLayout>
    );
}

export default WMSSummary;